import React from "react";
import { Button } from "@mantine/core";
import "./PrimaryButton.scss";
import {
  isViewingAsAdmin,
  isActionBlockedForAdmin,
} from "../../helpers/adminAccess";

const PrimaryButton = ({
  text,
  leftSection,
  rightSection,
  onClick,
  variant,
  loading,
  type,
  style,
  color,
  disabled,
  className,
}) => {
  // If an admin is viewing a stakeholder in read-only mode, hide all add/create/edit/delete/save mutation buttons
  if (isViewingAsAdmin() && isActionBlockedForAdmin(text)) {
    return null;
  }

  return (
    <Button
      className={className}
      onClick={onClick}
      radius={8}
      size="md"
      color={color ? color : "var(--button-primary)"}
      leftSection={leftSection}
      rightSection={rightSection}
      style={{
        ...style,
        fontSize: "14px",
        fontWeight: 500,
      }}
      variant={variant || "filled"}
      loading={loading}
      type={type}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};

export default PrimaryButton;
